import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.96967 5.46967C7.26256 5.17678 7.73744 5.17678 8.03033 5.46967L11.0303 8.46967C11.3232 8.76256 11.3232 9.23744 11.0303 9.53033L8.03033 12.5303C7.73744 12.8232 7.26256 12.8232 6.96967 12.5303C6.67678 12.2374 6.67678 11.7626 6.96967 11.4697L9.43934 9L6.96967 6.53033C6.67678 6.23744 6.67678 5.76256 6.96967 5.46967Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }